/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { useEffect, Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  notification,
  Popover,
  Radio,
} from 'antd';
import PropTypes from 'prop-types';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Image from '@Uilib/h3Image';
import SoActions from '@Actions/sales/soActions';
import searchIcon from '@Images/icons/icon-search.png';
import H3Text from '@Uilib/h3Text';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import ProductActions from '@Actions/productActions';
import './style.scss';

/**
 *
 */
const ChangeLocation = ({
  user, getShopifyConnections, shopifyConnections, shopifyLocationId, getShopifyConnectionsLoading, updateFulfillmentLocation, updateFulfillmentLocationLoading, fulfillmentId, callback, tenantIdProductMapping, tenantId,
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [reason, setReason] = useState('');

  useEffect(() => {
    getShopifyConnections(user?.tenant_info?.org_id);
    // if (shopifyLocationId) {
    //   setSelectedLocation(Number(shopifyLocationId));
    // }
  }, []);

  const handleSubmit = () => {
    if (Number(shopifyLocationId) !== selectedLocation) {
      const payload = {
        fulfillment_id: fulfillmentId,
        location_id: selectedLocation?.id,
        reason,
      };
      updateFulfillmentLocation(payload, () => {
        callback();
      });
    } else {
      notification.error({
        message: 'Cannot move to the current origin location',
        placement: 'top',
        duration: 4,
      });
    }
  };

  // const availableLocations = shopifyConnections?.[0]?.locations?.filter((location) => !(location?.tenant_id == tenantId));
  const availableLocations = shopifyConnections?.[0]?.locations;

  return (
    <Fragment>
      <div className="ch-header__wrapper-outer">
        {
          !getShopifyConnectionsLoading && shopifyConnections ? (
            <Fragment>
              <div className="switch-sl__wrapper">

                <div className="">
                  <div className="">
                    <H3Text text="Reason (optional)" className="reason-sl__text" />
                    <input
                      value={reason}
                      className="reason-sl__input"
                      onChange={(event) => setReason(event.target.value)}
                      placeholder="add reason for change in location.."
                      disabled={getShopifyConnectionsLoading}
                    />
                  </div>
                </div>
                <div className="switch-sl__list-header">
                  {`My Shopify Locations ${shopifyConnections?.[0]?.locations?.length > 1 ? `(${shopifyConnections?.[0]?.locations?.length})` : '' }`}
                </div>
                {shopifyConnections?.[0]?.locations?.length > 4 && (
                  <div className="switch-sl__list-search">
                    <input
                      placeholder="search business unit.."
                      onChange={(event) => setSearchKeyword(event.target.value)}
                    />
                    <H3Image src={searchIcon} className="switch-sl__list-search-icon" />
                  </div>
                )}
                <div className="switch-sl__list" style={{ paddingBottom: '50px' }}>
                  <Radio.Group onChange={(event) => setSelectedLocation(event?.target?.value)} value={selectedLocation}>
                    {
                      availableLocations
                        ?.filter((item) => (item?.name?.toLowerCase()?.includes(searchKeyword?.toLowerCase()) || item?.legal_name?.toLowerCase()?.includes(searchKeyword?.toLowerCase())))
                        ?.map((item) => (
                          (item?.tenant_id != tenantId && typeof item?.tenant_id !== 'undefined'
                            ? (
                              <Popover
                                key={item?.id}
                                title={`${tenantIdProductMapping[item?.tenant_id]?.unavailableProducts?.length} Unavailable Products.`}
                                placement="topLeft"
                                content={(
                                  <Fragment>
                                    {tenantIdProductMapping[item?.tenant_id]?.unavailableProducts?.map((unavailableProduct) => (
                                      <div key={unavailableProduct?.product_sku_id}>{`> ${unavailableProduct?.product_sku_name}`}</div>
                                    ))}
                                  </Fragment>
                                )}
                                trigger={tenantIdProductMapping[item?.tenant_id]?.unavailableProducts?.length === true && 'hover'}
                              >

                                <Radio value={item} className={`switch-sl__item-wrapper ${item?.id === selectedLocation?.id ? 'switch-sl__item-selected-wrapper' : ''}`} disabled={!tenantIdProductMapping[item?.tenant_id]?.availableProducts?.length && typeof tenantIdProductMapping[item?.tenant_id]?.availableProducts?.length !== 'undefined'}>
                                  <div className="switch-sl__item">
                                    <H3Text text={item?.tenant_name} className="switch-sl__item-name" />
                                    <H3Text text={tenantIdProductMapping[item?.tenant_id]?.unavailableProducts?.length && typeof tenantIdProductMapping[item?.tenant_id]?.unavailableProducts?.length !== 'undefined' ? `${tenantIdProductMapping[item?.tenant_id]?.unavailableProducts?.length} product(s) unavailable` : 'All products available'} className={tenantIdProductMapping[item?.tenant_id]?.unavailableProducts?.length ? 'switch-sl__item-unavailable' : 'switch-sl__item-available'} />
                                  </div>
                                </Radio>
                              </Popover>
                            ) : (
                              item?.tenant_name
                              && (
                                <Radio
                                  key={item?.id}
                                  value={item}
                                  className={`switch-sl__item-wrapper ${item?.id === selectedLocation?.id ? 'switch-sl__item-selected-wrapper' : ''}`}
                                  disabled
                                >
                                  <div className="switch-sl__item">
                                    <H3Text text={item?.tenant_name} className="switch-sl__item-name" />
                                    <H3Text text="Current Location" className="switch-sl__item-address" />
                                  </div>
                                </Radio>
                              )
                            ))
                        ))
                    }
                  </Radio.Group>
                </div>
                <div className="custom-drawer__footer">
                  <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="Change Location"
                      style={{
                        width: '200px',
                        borderRadius: '5px',
                        padding: '7px 0px',
                        marginLeft: '0',
                      }}
                      disabled={updateFulfillmentLocationLoading}
                      onClick={() => handleSubmit()}
                      isLoading={updateFulfillmentLocationLoading}
                    />
                  </div>
                </div>
              </div>
            </Fragment>
          ) : (
            <div className="switch-sl__wrapper">
              <div className="loading-switch-sl-header">
                <div className="loadingBlock loading-switch-sl-search" />
              </div>
              <div className="loading-switch-sl-body">
                <div className="loadingBlock loading-switch-sl-location" />
                <div className="loadingBlock loading-switch-sl-location" />
                <div className="loadingBlock loading-switch-sl-location" />
              </div>
            </div>
          )
        }
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  updateFulfillmentLocation: (payload, callback) => dispatch(SoActions.updateFulfillmentLocation(payload, callback)),
  getOrgProductById: (orgId, tenantId, productSkuId, callback) => dispatch(ProductActions.getOrgProductById(orgId, tenantId, productSkuId, callback)),
});
const mapStateToProps = ({
  UserReducers, CartReducers, ShopifyIntegrationReducers, SOReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  cart: CartReducers.cart,
  org: UserReducers.org,
  getOrgLoading: UserReducers.getOrgLoading,
  updateOrgLoading: UserReducers.updateOrgLoading,
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  updateFulfillmentLocationLoading: SOReducers.updateFulfillmentLocationLoading,
  getOrgProductByIdLoading: ProductReducers.getOrgProductByIdLoading,
  selectedOrgProduct: ProductReducers.selectedOrgProduct,
});

ChangeLocation.propTypes = {
  user: PropTypes.any,
  shopifyLocationId: PropTypes.any,
  getShopifyConnections: PropTypes.func,
  updateFulfillmentLocation: PropTypes.func,
  getShopifyConnectionsLoading: PropTypes.bool,
  updateFulfillmentLocationLoading: PropTypes.bool,
  shopifyConnections: PropTypes.any,
  fulfillmentId: PropTypes.any,
  callback: PropTypes.any,
  tenantIdProductMapping: PropTypes.any,
  tenantId: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChangeLocation));
